import { get, post } from '../utils/request';

export const getPreviewImages = function () {
  return get('url', {});
};

export const requestFullPreview = function (fullPreviewRequest) {
  return post('/api/v1/FullPreview', fullPreviewRequest);
};

export const setUseScene7TemplateSession = function (useScene7TemplateSessionRequest, config) {
  const url =
    '/api/v1/UseScene7Template?itemUseScene7Template=' +
    useScene7TemplateSessionRequest.itemUseScene7Template +
    '&cartUseScene7Template=' +
    useScene7TemplateSessionRequest.cartUseScene7Template +
    '&isEdit=' +
    useScene7TemplateSessionRequest.isEdit;
  return get(url, null, config);
};
export const requestCanvasPreview = (canvasPreviewRequest) => {
  return post('/api/v1/FullPreview/getCanvasPreview', canvasPreviewRequest);
};
